<template>
  <modal :show="isOpen" @close="isOpen = false">
    <template #header>
      <h5 class="modal-title">
        {{ $t(modalAuthUpdate === 'email' ? "Change email address" : "Change phone number") }}
      </h5>
    </template>
    <div class="row">
      <div class="col-lg-12">
    <div v-if="modalAuthUpdate === 'email'" class="form-group has-label">
      <base-input
          v-model="emailAddress"
          alternative=""
          label="Email address"
          placeholder="Email address"
          input-classes="form-control-alternative"
          :error="v$.emailAddress.$errors.map( err => { return err.$message })[0]"
      >
        <template #infoBlock>
          <span class="w-100 text-sm text-muted">{{ $t("After the update you may need to log in again") }}</span>
        </template>
      </base-input>
    </div>
    <div v-if="modalAuthUpdate === 'phoneNumber'" class="form-group has-label">
      <label class="form-control-label float-start">{{ $t("Phone number") }}</label>
      <base-input
          v-model="phoneNumber"
          type="number"
          form-classes="input-group-alternative mb-3 phone-input"
          style="display: flex;border-radius: 0;"
          :placeholder="$t('Contact Phone')"
          :error="v$.phoneNumber.$errors.map( err => { return err.$message })[0]"
      >
        <template #addonLeft>
          <multiselect
              v-model="phoneNumberCode"
              :options="countryCodes"
              placeholder=""
              :show-labels="false"
              :searchable="true"
              :custom-label="customLabel"
              required
              :multiple="false"
              class=""
          >
            <template #singleLabel="{ option }">
              <img v-if="option.iso" alt="Country flag" width="25" :src="require('@/assets/images/flags/'+option.iso.toUpperCase()+'.png')" />
              {{ option.code }}
            </template>
            <template #option="props">
              <img v-if="props.option.iso" alt="Country flag" width="25" :src="require('@/assets/images/flags/'+props.option.iso.toUpperCase()+'.png')" />
              {{ props.option.text }}
            </template>
          </multiselect>
        </template>
        <template #infoBlock>
          <span class="w-100 text-sm text-muted">{{ $t("After the update you will need to log in again with the new phone number provided") }}</span>
        </template>
      </base-input>
    </div>
      </div>
      <div class="col-12 text-end">
        <base-button class="me-2" outline type="info" @click="isOpen = false">{{ $t("Cancel") }}</base-button>
        <submit-button :alert-message="errorMessage" :state="loadingProcess" @clicked="submit()">{{ $t('Submit') }}</submit-button>
      </div>
    </div>
  </modal>
</template>
<script>
import Modal from "@/components/Modal.vue"
import BaseInput from "@/components/BaseInput.vue"
import {email, helpers, requiredIf} from "@vuelidate/validators"
import useVuelidate from "@vuelidate/core"
import {getCountries, getCountryCallingCode, isValidNumber, parsePhoneNumber} from "libphonenumber-js"
import {isoCountryCodeToFlagEmoji, isWindows} from "@/helpers/common"
import BaseButton from "@/components/BaseButton.vue"
import SubmitButton from "@/components/SubmitButton.vue"
import FirebaseFunctionsHelper from "@/helpers/firebaseFunctionsHelper"
const isValidPhone = (param) => helpers.withParams(
    { type: "isValidPhone", value: param }, (value) => {

      if (value == null || value === ""){
        return true
      }
      console.log("param+value", param+value)
      return isValidNumber(param+value)
    })

export default {
  name: "UpdateAuth",
  components: {SubmitButton, BaseButton, BaseInput, Modal},
  props: {
    modalAuthUpdate: {
      type: String,
      required: true,
      default: "",
    },
    authValue: {
      type: String,
      required: true,
      default: "",
    },
    authId: {
      type: String,
      required: false,
      default: null,
    }
  },
  emits: ["onClose"],
  setup: () => ({ v$: useVuelidate() }),
  data() {
    return {
      userId: null,
      updated: false,
      errorMessage: "",
      loadingProcess: "",
      countryCodes: [],
      emailAddress: "",
      phoneNumber: "",
      phoneNumberCode: {code: "+357", text: this.$t("CY") + " +357", iso: "CY"},
      isOpen: false,
    }
  },
  validations () {
    return {
      phoneNumber: {
        validated: helpers.withMessage(this.$t("Must be valid phone number."), isValidPhone(this.phoneNumberCode?.code)),
        requiredIf: helpers.withMessage(this.$t("Value is required"), requiredIf(this.modalAuthUpdate === "phoneNumber"))
      },
      emailAddress: {
        email: email,
        requiredIf: helpers.withMessage(this.$t("Value is required"), requiredIf(this.modalAuthUpdate === "email"))
      },
    }
  },
  watch:{
    modalAuthUpdate: function (newVal) {
      this.isOpen = newVal !== ""
      console.log("modalAuthUpdate", newVal)
      console.log("modalAuthUpdate", this.authValue)
      if (newVal === "email"){
        this.emailAddress = this.authValue
      }
      if (newVal === "phoneNumber"){
        let phoneDetails = parsePhoneNumber(this.authValue)
        console.log("phoneDetails", phoneDetails)
        this.phoneNumber = phoneDetails.nationalNumber ?? null
        this.phoneNumberCode = {code: phoneDetails.countryCallingCode ?? "+357", text: this.$t(phoneDetails.country ?? "CY") + " " + phoneDetails.countryCallingCode, iso: phoneDetails.country ?? "CY"}

      }
    },
    authId: function (newVal) {
      this.userId = newVal
    },
    isOpen: function (newVal) {
      if (!newVal) {
        this.$emit("onClose", this.updated ? (this.modalAuthUpdate === "phoneNumber" ? this.phoneNumberCode.code + this.phoneNumber: this.emailAddress) : null)
      }
    }
  },
  mounted() {
    let countries = ["CY", "GB", "GR"]

    countries.forEach(country => {
      let code = getCountryCallingCode(country)
      this.countryCodes.push({code: "+" + code, text: this.$t(country) + " +" + code, iso: country})
    })
  },
  methods: {
    customLabel(option) {
      return `${option.text}`
    },
    submit(){
      this.v$.$touch()

      if (this.v$.$invalid) {
        console.log(this.v$.$errors)
        return
      }

      this.loadingProcess = "processing"

      let id = ""
      if (this.userId){
        id = this.userId
      } else if (["employeeProfile", "accountGeneral"].includes(this.$route.name)){
        id = this.$store.state.user.claims.user_id
      } else {
        id = this.$route.params.id
      }
      const payload = {
        id: id
      }

      if (this.modalAuthUpdate === "email") {
        payload["email"] = this.emailAddress
      } else {
        payload["phoneNumber"] = this.phoneNumberCode.code + this.phoneNumber
      }
      FirebaseFunctionsHelper.callFunction(
          "auth-update",
          // eslint-disable-next-line no-undef
          payload
      )
          .then((result) => {
            console.log("res", result)
            // eslint-disable-next-line no-prototype-builtins
            if (result != null && result.hasOwnProperty("message")) {
              console.log("result message", result.message)
              this.loadingProcess = "failed"
              this.errorMessage = result.message
              return
            }
            this.updated = true
            console.log("submitUser result", result)
            this.loadingProcess = "done"

            this.isOpen = false
          })
          .catch((error) => {
            this.loadingProcess = "failed"
            this.errorMessage = error.message
            console.log("submitUser error", error)
          })
    },
    isoCountryCodeToFlagEmoji,
    isWindows() {
      return isWindows
    }
  },
}
</script>



<style scoped>

</style>